import React from 'react';
import { Home, Sparkles } from 'lucide-react';

const Logo = ({ className = "h-14", variant = "color" }) => {
  const isWhite = variant === "white";
  
  return (
    <div className={`${className} flex items-center space-x-2`}>
      <div className="relative">
        <Home 
          className={`w-10 h-10 ${isWhite ? 'text-white' : 'text-cyan-600'}`}
          strokeWidth={2}
        />
        <Sparkles 
          className={`w-4 h-4 ${isWhite ? 'text-white' : 'text-cyan-500'} absolute -top-1 -right-1`}
          fill={isWhite ? 'white' : '#06b6d4'}
        />
      </div>
      <div className="flex flex-col -space-y-1">
        <span className={`text-xl font-bold ${isWhite ? 'text-white' : 'text-gray-900'}`}>
          EKJ NETTOYAGE
        </span>
        <span className={`text-[10px] ${isWhite ? 'text-cyan-200' : 'text-cyan-600'} font-medium tracking-wide`}>
          NETTOYAGE INDUSTRIEL & PARTICULIER
        </span>
      </div>
    </div>
  );
};

export default Logo;
